/* eslint-disable no-undef */
import $ from "jquery";

const realtedProduct = () => {
  const init = () => {
    handleClickPlus();
    handleClickInput();
    handleClickMinus();
  };

  const handleClickPlus = () => {
    const el = {
      minus: ".js-add2cart-product-button-minus",
      plus: ".js-add2cart-product-button-plus",
    };

    $(document).on("click", el.plus, function (e) {
      e.preventDefault();
      $(this).parent().addClass("open");
      $(this).parent().addClass("has_value");

      const $fromMinicart =
        $(this).closest(".js-header-mini-cart").length > 0 ? true : false;

      const input = $(`#${$(this).data("for")}`);
      const inputValue = parseInt(input.val());
      const productId = $(`#${$(this).data("for")}`).data("product_id");

      const maxValue =
        input.attr("max") != "" ? parseInt(input.attr("max")) : false;

      const action = (thisEl) => {
        input.val(parseInt(input.val()) + 1);

        if (input.val() > 0) {
          thisEl.parent().find(el.minus).removeClass("disabled");
        }
      };

      if (!maxValue) {
        action($(this));
      } else {
        if (inputValue < maxValue) {
          action($(this));
          $(this).addClass("disabled");
        }
      }

      ajaxAdd2cart($(this), productId, input.val(), input, $fromMinicart);
    });
  };

  const handleClickInput = () => {
    const el = {
      minus: ".js-add2cart-product-button-minus",
      input: ".js-add2cart-product-button-minus + input",
      plus: ".js-add2cart-product-button-plus",
    };

    $(document).on("focus", el.input, function (e) {
      e.preventDefault();
      const parent = $(this).parent();
      parent.addClass("open");
    });

    $(document).on("blur", el.input, function (e) {
      e.preventDefault();
      const parent = $(this).parent();
      setTimeout(() => {
        parent.removeClass("open");
      }, 3000);
    });
  };

  const handleClickMinus = () => {
    const el = {
      minus: ".js-add2cart-product-button-minus",
      plus: ".js-add2cart-product-button-plus",
    };

    $(document).on("click", el.minus, function (e) {
      e.preventDefault();
      $(this).parent().addClass("open");
      $(this).parent().addClass("has_value");
      const $fromMinicart =
        $(this).closest(".js-header-mini-cart").length > 0 ? true : false;

      const input = $(`#${$(this).data("for")}`);
      const inputValue = parseInt(input.val());
      const parent = $(this).parent();
      const productId = $(`#${$(this).data("for")}`).data("product_id");

      $(this).parent().find(el.plus).removeClass("disabled");

      if (inputValue > 0) {
        input.val(parseInt(input.val()) - 1);
        if (input.val() == 0) {
          $(this).addClass("disabled");
          parent.removeClass("has_value");
        }
      }

      ajaxAdd2cart($(this), productId, input.val(), input, $fromMinicart);
    });
  };

  const ajaxAdd2cart = (thisEl, productId, qty, inputEl, minicart = false) => {
    $.ajax({
      type: "POST",
      dataType: "json",
      url: themeObj.ajaxUrl,
      data: {
        action: themeObj.add2cart.action,
        nonce: themeObj.add2cart.nonce,
        product_id: productId,
        quantity: qty,
        cart_item_key: inputEl.data("cart_item_key"),
        is_increament: false,
        is_mini_cart: minicart,
      },
      beforeSend() {
        //   thisEl.addClass("disabled");
      },
      success(response) {
        thisEl.parent().removeClass("open");
        animation(thisEl);

        const el = {
          counterEl: ".js-counter-cart",
          minicart: ".js-minicart",
        };

        const counter = response.data.count;
        const html = response.data.html;
        $(el.counterEl).text(counter);
        $(el.minicart).html(html);

        const fragments = response.data.fragments;
        $.each(fragments, (key, obj) => {
          $(key).html(obj);
        });

        jQuery(document.body).trigger("wc_fragment_refresh");
      },
      error(response) {
        if (response.responseJSON.data.redirect) {
          window.location.href = response.responseJSON.data.redirect;
        }
      },
      complete() {},
    });
  };

  const animation = (thisEl) => {
    const toPosition = $(".js-menu-cart").offset();
    const topEl = thisEl.parent().offset().top - $(window).scrollTop();
    const product = thisEl.parents(".box-product");
    const image = product.find(".wrapper-img img");
    image.clone().appendTo(product);

    const newImage = product.find("> img");

    newImage
      .css("position", "fixed")
      .css("left", `${thisEl.parent().offset().left}px`)
      .css("top", `${topEl}px`)
      .css("opacity", `1`);

    newImage.animate(
      {
        top: 30 + "px",
        left: toPosition.left + "px",
        opacity: 0.2,
        width: "20px",
        height: "20px",
      },
      1000,
      function () {
        newImage.remove();
      }
    );
  };

  init();
};

try {
  realtedProduct();
} catch (error) {
  // eslint-disable-next-line no-console
  console.error(error);
}
